import { gbp } from '../invoice/invoiceUtils';

export const PO_STATUS = {
  open: { label: 'Open', cls: 'bg-[#F5A623]/15 text-[#F5A623] border-[#F5A623]/30' },
  collected: { label: 'Collected', cls: 'bg-sky-500/15 text-sky-300 border-sky-500/30' },
  matched: { label: 'Invoice matched', cls: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30' },
  cancelled: { label: 'Cancelled', cls: 'bg-red-500/15 text-red-300 border-red-500/30' },
};
export const PO_CATEGORIES = [['material', 'Materials'], ['plant', 'Plant'], ['fuel', 'Fuel'], ['other', 'Other']];
export const pence = (p) => gbp((Number(p) || 0) / 100);
export const ageLabel = (h) => (h == null ? '' : h < 1 ? 'just now' : h < 48 ? `${Math.round(h)}h open` : `${Math.floor(h / 24)}d open`);

export function PoStatusBadge({ status, overdue }) {
  const s = PO_STATUS[status] || PO_STATUS.open;
  return (
    <span className={`text-[10px] px-2 py-0.5 rounded-full border whitespace-nowrap ${status === 'open' && overdue ? 'bg-red-500/15 text-red-300 border-red-500/30' : s.cls}`} data-testid="po-status">
      {status === 'open' && overdue ? 'Open · overdue' : s.label}
    </span>
  );
}
